<template>
    <a href="#" @click.prevent="setMaxUpsell">
        <div class="upsell-card">
            <div class="text">
                <div class="inner">
                    <p v-if="maximumSeasonSelected">
                        Our best value season ticket, saving you £{{ maxSaving | currencyFormat(true) }} over {{ seasonUpsellObject.billing.interval_count }} months.
                    </p>
                    <p v-else>
                        Pay up-front for {{ seasonUpsellObject.billing.interval_count }} months & save £{{ maxSaving | currencyFormat(true) }} compared to paying monthly.
                        <span>Upgrade now</span>
                    </p>
                </div>
            </div>
            <div class="price">
                <div class="inner">
                    <p v-if="maximumSeasonSelected">
                        <strong>£{{ maxSaving | currencyFormat(true) }}</strong>
                        <small>Saving</small>
                    </p>
                    <p v-else>
                        <small>Save</small>
                        <strong>£{{ maxSaving | currencyFormat(true) }}</strong>
                    </p>
                </div>
            </div>
        </div>
    </a>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: 'season-ticket-upsell',

        computed: {
            ...mapGetters('booking', [
                'seasonUpsellObject',
                'seasonIntervalData',
                'lowestIntervalSeason',
            ]),

            maximumSeasonSelected() {
                return this.seasonUpsellObject.billing.interval_count === this.seasonIntervalData.billing.interval_count;
            },

            maxSaving() {
                return (this.lowestIntervalSeason.cost.total * 12) - this.seasonUpsellObject.cost.total;
            },
        },

        methods: {
            /**
             * Set the season interval to the max upsell
             */
            setMaxUpsell() {
                this.$store.commit('booking/setIntervalCount', this.seasonUpsellObject.billing.interval_count);
            },
        },
    };
</script>

<style lang="less" scoped>
    @import (reference) "~assets/less/variables";

    .upsell-card {
        position: relative;
        overflow: hidden;
        border-radius: 6px;
        display: flex;
        color: #ffffff;
        background-color: darken(@YPS-secondary, 10%);
        font-size: 14px;
        margin: 10px 10px 5px;
        span {
            position: relative;
            z-index: 2;
        }
        &:before {
            content: '';
            position: absolute;
            z-index: 1;
            height: 100%;
            top: 0;
            left: -10%;
            width: 80%;
            background-color: fade(@YPS-secondary, 90%);
            transform: skew(-20deg);
        }
        &:hover {
            &:before {
                animation-name: shine;
                animation-duration: 0.8s;
            }
        }

        @keyframes shine {
            0%   {
                left: -10%;
            }
            49% {
                left: 110%;
            }
            50% {
                left: -100%;
            }
            100% {
                left: -10%;
            }
        }
    }

    .partner-location {
        .upsell-card {
            border-radius: 0;
            margin: 15px 15px 5px;
            background: #e6e6e6;
            color: #000000;
            &:before {
                left: -85px;
                width: 100%;
                background-color: #f1f1f1;
                transform: skew(0);
            }
            &:hover {
                &:before {
                    animation-name: unset;
                }
            }
        }

        .price {
            padding: 12px;
            font-size: 24px;
            min-width: 80px;
            small {
                font-size: .6em;
            }
        }

        .text {
            padding: 15px;
            span {
                display: block;
                color: #1e9561;
                text-decoration: none;
                margin-top: 5px;
            }
        }
    }

    a {
        color: #ffffff;
        text-decoration: none;
        &:hover {
            text-decoration: none;
            .text {
                span {
                    opacity: 0.5;
                }
            }
        }
    }

    p {
        margin: 0;
    }

    .text, .price {
        padding: 15px 20px;
        display: flex;
        align-items: center;
        position: relative;
        z-index: 2;
    }

    .text {
        flex-grow: 1;
    }

    .price {
        font-size: 20px;
        text-align: center;
        small {
            font-size: .65em;
            display: block;
        }
    }

    .text {
        position: relative;
        padding-right: 40px;
        span {
            color: inherit;
            font-weight: bold;
            text-decoration: underline;
            opacity: 1;
            transition: 0.3s;
        }
        .inner {
            position: relative;
            z-index: 1;
        }
    }
</style>
